import { apiClient } from '@api/client';
import type {
  CheckoutSessionRequest,
  CheckoutSessionResponse,
  PortalSessionResponse,
  PaymentMethodSummary,
} from '@/types/billing';

export const createCheckoutSession = async (body: CheckoutSessionRequest): Promise<CheckoutSessionResponse> => {
  const { data } = await apiClient.post<CheckoutSessionResponse>('/billing/checkout-session', body);
  return data;
};

export const createPortalSession = async (returnUrl: string): Promise<PortalSessionResponse> => {
  const { data } = await apiClient.post<PortalSessionResponse>('/billing/portal-session', { return_url: returnUrl });
  return data;
};

export const getPaymentMethod = async (): Promise<PaymentMethodSummary> => {
  const { data } = await apiClient.get<PaymentMethodSummary>('/billing/payment-method');
  return data;
};
